/* global TD */
import $ from "jquery";
import "jquery-ui-multiselect-widget";
import "jquery-ui-multiselect-widget/src/jquery.multiselect.filter";

function updateFilter(msel) {
	if (msel[0].options.length >= 30) {
		msel.multiselectfilter({
			label: "",
			placeholder: TD.Res["dbui.search.button"],
			create: function () {
				var el = $(this);
				var input = $(this).multiselectfilter("widget").find("input");
				input.on("keydown", function (e) {
					if (e.which === 13) {
						el.multiselect("checkAll");
						e.stopPropagation();
						e.preventDefault();
						this.focus();
					}
				});
			}
		});
	}
}

function initMultiChoice(ctx) {
	$("select.td-multichoice", ctx).each(function (i, me) {
		const msel = $(me);
		const initOptions = {
			buttonWidth: "auto",
			beforeopen: function () {
				var msel = $(this);
				var url = msel.attr("data-url");
				if (url) {
					// from view aspx
					var opt = new Option(String.format(TD.Res["form.load_detail"], ""));
					opt.setAttribute("disabled", "");
					msel.append(opt);
					msel.multiselect("refresh");
					$.ajax(url, {
						cache: false,
						dataType: "json",
						success: function (data) {
							msel.attr("data-url", null);
							msel.empty().append(data.map(function (item) { return new Option(item.text, item.value, item.selected, item.selected); }));
							msel.multiselect("refresh").multiselect("option", "menuHeight", "20em");
							updateFilter(msel);
						}
					});
				}
			},
			menuWidth: "auto",
			menuHeight: "20em",
			position: { my: "left top", at: "left bottom", collision: "flipfit" },
			noneSelectedText: TD.Res["form.choice.any"],
			selectedList: 14,
			linkInfo: {
				checkAll: {
					text: TD.Res["form.choice.select_all"]
				},
				uncheckAll: {
					text: TD.Res["form.choice.select_none"]
				}
			},
			create: function () {
				$(this).multiselect("getButton").addClass("ui-button ui-icon-drop white");
				$(this).multiselect("widget").addClass("ui-popup")
					.find(">ul.ui-multiselect-checkboxes").addClass("ui-menu")
					.find(">li").addClass("ui-menu-item");
			}
		};
		if (ctx) {
			initOptions.appendTo = ctx;
		}
		msel.multiselect(initOptions);
		updateFilter(msel);
	});
}

export { initMultiChoice };